$(document).ready(function(){
  let urlHref = window.location.href;
  let newStringHref = urlHref.slice(0, -1);
  let urlOrigin = window.location.origin
  // console.log(newStringHref);
  // console.log(urlOrigin);
  if (newStringHref == urlOrigin) {
      $('.header__inner .header__action-list .desktop').show();
    }
  let width = $(window).width();

  if (width <= 768) {
    if (newStringHref == urlOrigin) {
      $('.header__inner .header__action-list .desktop').hide();
      $('.header__inner .header__action-list .mobile').show();
    }
  }
});